const route = {
	login: { path: '/login', title: 'Login' },
	dashboard: { path: '/', title: 'Dashboard' },
	fuelSale: { path: '/FuelSaleNew', title: 'Fuel Sale' },
	comingSoon: { path: '/coming-soon', title: 'Coming Soon' },
	report: { path: '/report', title: 'report' },
}

export default route
